import { css, FlattenSimpleInterpolation, CSSObject } from "styled-components"

type TVariant = FlattenSimpleInterpolation | CSSObject | null

type TVariantObject = {
  sm?: TVariant
  md?: TVariant
  lg?: TVariant
}

type TVariantArray = TVariant[]

export type TVariantProp = TVariantArray | TVariantObject

export function handleArrayVariants(arr: TVariantArray) {
  return {
    sm: arr[0],
    md: arr[1],
    lg: arr[2],
  }
}

export default function mergeVariants(
  defaultVariant?: TVariantProp,
  overrideVariant?: TVariantProp
) {
  const defaultVar = Array.isArray(defaultVariant)
    ? handleArrayVariants(defaultVariant)
    : defaultVariant
  const override = Array.isArray(overrideVariant)
    ? handleArrayVariants(overrideVariant)
    : overrideVariant

  const merged = {
    sm: css`
      ${defaultVar?.sm};
      ${override?.sm};
    `,
    md: css`
      ${defaultVar?.md};
      ${override?.md};
    `,
    lg: css`
      ${defaultVar?.lg};
      ${override?.lg};
    `,
  }

  return merged
}
